import src from "IMAGE";
export default { src, width: 221, height: 98, blurWidth: 0, blurHeight: 0};
